<template>
  <div class="projects-container">
    <Header></Header>
    <div class="projects-body">
      <h1>Projects</h1>
      <section class="video-list">
        <!-- <el-row :gutter="40">
          <el-col
            :xs="24"
            :sm="12"
            :md="12"
            :lg="12"
            :xl="12"
            v-for="(item, index) in videoList"
            :key="index"
          >
            <div class="video-box">
              <video :src="item.url" controls="controls">
                您的浏览器不支持 video 标签。
              </video>
              <div class="group-info">
                <span class="label">小组成员: </span>
                <span v-for="(stu, index) in item.group" :key="index + 'stu'">{{
                  index === item.group.length - 1 ? stu : `${stu}、`
                }}</span>
              </div>
            </div>
          </el-col>
        </el-row> -->
        <el-row
          v-for="(item, index) in videoList"
          :key="index"
          class="video-box"
        >
          <el-row><h2>{{ item.name }}</h2></el-row>
          <el-row :gutter="24">
            <el-col :span="10">
              <div>
                <video :src="item.url" controls="controls">
                  您的浏览器不支持 video 标签。
                </video>
              </div>
            </el-col>
            <el-col :span="14">
              <div>
                <div class="group-info">
                  <span class="label">项目简介：</span>
                  <span>{{ item.project }}</span>
                </div>
                <div class="group-info">
                  <span class="label">小组成员：</span>
                  <span v-for="(stu, index) in item.group" :key="index + 'stu'">{{
                    index === item.group.length - 1 ? stu : `${stu}、`
                  }}</span>
                </div>
                <div class="group-info">
                  <span class="label">完成学期：</span>
                  <span>2019-2020-2</span>
                </div>
              </div>
            </el-col>
          </el-row>
        </el-row>
      </section>
    </div>
    <Footer></Footer>
  </div>
</template>
<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
export default {
  components: { Header, Footer },
  data() {
    return {
      videoList: [
        {
          name: "Group 1",
          project:
            "总的来说，我们开发了一个网站，里面包含了中国大学和学院的不同专业的数据，可以为刚刚参加高考，对专业选择还不清楚的学生提供很多有用的信息。相比其他一些网站如eol.cn或chsi.com.cn,我们有信心做的比他们领域的专业更好,因为我们不仅有图片,我们还也有更多的数据和更好可视化。",
          url: "https://dataset.acemap.info/dgdb2020/1.mp4",
          group: [
            "李竞翔",
            "万旭豪",
            "王煌基",
            "龙浩文",
            "周文杏",
            "谭志宇",
            "李晓玮",
            "胡向飞",
          ],
        },
        {
          name: "Group 5",
          project:
            "我们开发了一个集电影推荐、电影排名和电影可视化于一体的网站。",
          url: "https://dataset.acemap.info/dgdb2020/2.mp4",
          group: [
            "辛泽玮",
            "林雨桐",
            "李昊明",
            "黄柳豫",
            "卢若添",
            "孙家琦",
            "于永为",
            "苗家宁",
            "薛琛辉",
            "陈锦涛",
          ],
        },
        {
          name: "看似绝望实则充满希望的第六小组",
          project:
            "iCrescendo是一个基于网易云音乐进行数据分析的网站，i代表着所钟爱的歌曲，而Crescendo意思是音乐的渐强、热门，指代我们网站的特色在于为用户描绘令他们心跳加速的音乐和歌手。iCrescendo搭建的主要目的在于：用可视化的形式为用户带来最直观的感受，让用户能一目了然音乐的影响力和音乐的画像。",
          url: "https://dataset.acemap.info/dgdb2020/3.mp4",
          group: [
            "许灏瑄",
            "杨淑祺",
            "张若涵",
            "舒一乐",
            "周天宇",
            "江书洋",
            "叶丹妮",
            "周凌枫",
            "董宇胜",
            "佟庆月",
          ],
        },
        {
          name: "吊炸天超级无敌电工组（DZT）",
          project:
            "我们的项目名称为：《Shape of Voice》，是一个以数据分析为主要卖点的音乐相关网站，我们从网易云获取数据，并且分析，然后呈现。本着科技让生活更加美好的想法，我们开展了这个项目，希望能够使得非专业人士或者专业人士，他们只要拥有着音乐爱好者这个共同的身份，就能通过我们的项目，滑动，点击之间，简单地感受到音乐的背后，数据的魅力。",
          url: "https://dataset.acemap.info/dgdb2020/4.mp4",
          group: [
            "陈赓",
            "宋雅昆",
            "唐灵",
            "高金焘",
            "徐博",
            "饶洋",
            "李奕霏",
            "周毓",
            "刘迪一",
            "张乐",
          ],
        },
        {
          name: "Group 8",
          project:
            "游戏是当代许多年轻人娱乐、消遣的主要方式，而许多人也苦于找不到合适的游戏。我们开发这一网站的初衷便是能让大家更快速、准确地找到自己喜爱的、适合地游戏。",
          url: "https://dataset.acemap.info/dgdb2020/5.mp4",
          group: [
            "宋家鑫",
            "蔡文睿",
            "刘一哲",
            "马星伟",
            "刘思源",
            "陶浥尘",
            "郭童",
            "石蒙锐",
            "李天泽",
            "刘琦",
          ],
        },
        {
          name: "Group 11",
          project:
            "本网站对于1920-2020年间的动漫信息进行了可视化展示，旨在通过图片、动态效果与文字，直观地呈现出动漫的发展、信息以及动漫之间的联系。",
          url: "https://dataset.acemap.info/dgdb2020/6.mp4",
          group: [
            "时翊铭",
            "李泽辰",
            "张羽桐",
            "王文茜",
            "张展旗",
            "牛天一",
            "张润天",
            "韦俊杰",
            "于大方",
            "方禹舜",
          ],
        },
      ],
    };
  },
};
</script>
<style lang="less" scoped>
.projects-container {
  font-family: Source Sans Pro;
  .projects-body {
    width: 1080px;
    margin: 175px auto;
    video {
      width: 100%;
      // height: 360px;
    }
    .video-box {
      text-align: left;
      padding: 24px;
      background: #ffffff;
      box-shadow: 0px 4px 5px rgba(0, 0, 0, 0.25);
      border-radius: 5px;
      // height: 390px;
      margin-bottom: 48px;
    }
    h1 {
      font-weight: 900;
      font-size: 64px;
      line-height: 56px;
      color: #000000;
      margin-bottom: 64px;
      text-align: left;
    }
    h2 {
      font-weight: 600;
      font-size: 22px;
      line-height: 24px;
      margin-bottom: 16px;
    }
    .group-info {
      line-height: 24px;
      margin-bottom: 12px;
      .label {
        font-weight: 700;
      }
    }
  }
}
</style>